module.exports = __webpack_public_path__ + "img/list-img2.1c0d4a63.png";